import { useSearchParams } from "react-router"
import { EntityEmptyDetail } from "../../shared/EntityEmptyDetail"
import { SendInquiryPanel } from "../../shared/SendInquiryPanel"
import { SupplierActiveWorkSection } from "../../shared/SupplierActiveWorkSection"
import { SupplierArticlesSection } from "./SupplierArticlesSection"
import { SupplierAuditSection } from "./SupplierAuditSection"
import {
  SupplierFieldsBody,
  SupplierFieldsHeader,
  useSupplierFieldsState,
} from "./SupplierFieldsSection"
import { SupplierNotesSection } from "./SupplierNotesSection"

interface SupplierDetailPanelProps {
  selectedIds: Set<string>
  onRemoveIds: (ids: string[]) => void
}

export function SupplierDetailPanel({
  selectedIds,
  onRemoveIds,
}: SupplierDetailPanelProps) {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")
  const fieldsState = useSupplierFieldsState()

  if (selectedIds.size > 0) {
    return (
      <SendInquiryPanel
        entityType="supplier"
        selectedIds={selectedIds}
        onRemoveIds={onRemoveIds}
      />
    )
  }

  if (!id) return <EntityEmptyDetail body="MC_MD_EMPTY_SELECT_BODY_SUPPLIER" />

  return (
    <div className="flex flex-col">
      <SupplierFieldsHeader state={fieldsState} />
      <SupplierActiveWorkSection supplierId={id} />
      <SupplierArticlesSection />
      <SupplierFieldsBody state={fieldsState} />
      {/* Keyed so a draft typed on one supplier is not carried to the next. */}
      <SupplierNotesSection key={id} supplierId={id} />
      <SupplierAuditSection />
    </div>
  )
}
